import {
  CriticalIcon,
  InformationIcon,
  SuccessIcon,
  UnavailableIcon,
  WarningIcon,
} from '@dynatrace/strato-icons';

import type { HealthIndicatorProps } from './health-indicator-types.js';
import {
  CriticalShape,
  GoodShape,
  IdealShape,
  NeutralShape,
  WarningShape,
} from './Shapes.js';

/**
 * The StatusVisual component is a helper component that decides whether an
 * icon or shape is returned.
 * @internal
 */
export const StatusVisual = (
  props: Pick<HealthIndicatorProps, 'status' | 'visual'>,
) => {
  const { status, visual } = props;

  switch (status) {
    case 'ideal':
      return visual === 'icon' ? <SuccessIcon /> : <IdealShape />;
    case 'good':
      return visual === 'icon' ? <InformationIcon /> : <GoodShape />;
    case 'warning':
      return visual === 'icon' ? <WarningIcon /> : <WarningShape />;
    case 'critical':
      return visual === 'icon' ? <CriticalIcon /> : <CriticalShape />;
    case 'neutral':
    default:
      return visual === 'icon' ? <UnavailableIcon /> : <NeutralShape />;
  }
};
